/* eslint-disable no-console */
import * as proj from 'ol/proj';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import { Fill, Stroke, Style, Circle } from 'ol/style.js';

const GROUP_ID = 'geojson-start-line';

const pointStyle = new Style({
  image: new Circle({
    radius: 6,
    fill: new Fill({ color: '#ff5c33' }),
    stroke: new Stroke({ color: '#ffffff', width: 2 }),
  }),
});

const lineStyle = new Style({
  stroke: new Stroke({
    color: '#ff5c33',
    width: 3,
  }),
});

/**
 * by_geojson モードで地図をクリックした2点から、
 * 表示用の点/線Featureと、GeoJSON(LineString Feature)テキストを作る。
 */
export default class GeojsonLine {
  constructor(points) {
    this.points = points || [];
    this.features = [];

    this.points.forEach((lonlat) => {
      let marker = new Feature({ geometry: new Point(proj.fromLonLat(lonlat)) });
      marker.setStyle(pointStyle);
      marker.groupId = GROUP_ID;
      this.features.push(marker);
    });

    if (this.points.length === 2) {
      let coordinates = this.points.map((lonlat) => proj.fromLonLat(lonlat));
      let line = new Feature({ geometry: new LineString(coordinates) });
      line.setStyle(lineStyle);
      line.groupId = GROUP_ID;
      this.features.push(line);
    }
  }

  getFeatures() {
    return this.features;
  }

  static toGeojsonText(points) {
    if (!points || points.length !== 2) {
      return null;
    }
    let geojson = {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: points,
      },
    };
    return JSON.stringify(geojson, null, 2);
  }
}
